<template>
  <div class="box">
    <div v-if="type == '0'">
      <div class="userAgreement">
        <p style="text-align: center">灏睿云医用户注册协议</p>
        <p style="text-align: right">更新日期：【2020】年【04】月【03】日</p>
        <p>提示条款</p>
        <p>
          您的信任对我们非常重要，灏睿云医（含义详见定义部分）制定本《灏睿云医用户注册协议》（或简称“本协议”）并提醒您：
        </p>
        <p>
          本协议适用于灏睿云医的互联网电子服务或商品（以下简称“本服务”）。如关联公司（范围详见定义部分）的互联网电子服务或商品中使用了灏睿云医提供的互联网电子服务或商品（例如直接使用灏睿云医账户登录）但未设独立用户注册协议的，则本协议同样适用于该部分互联网电子服务或商品。
        </p>
        <p>请您注意，本协议不适用于以下情况：</p>
        <p>
          1、通过我们的互联网电子服务或商品而接入的第三方服务（包括任何第三方网站）收集的信息；
        </p>
        <p>
          2、通过在我们互联网电子服务或商品中进行广告服务的其他公司或机构所收集的信息。
        </p>
        <p>
          在使用灏睿云医的各项互联网电子服务或商品前，请您务必仔细阅读并透彻理解本协议，在确认充分理解并同意后方可使用相关互联网电子服务或商品。一旦您开始使用灏睿云医互联网电子服务或商品，将被视为对本协议内容的接受和认可。
        </p>
        <p>
          如对本协议内容有任何疑问、意见或建议，您可通过客服中心<span
            style="color: #0000ff"
            >（http://www.hryunyi.com/）</span
          >与我们联系。
        </p>
        <p>定义</p>
        <p>
          《灏睿云医用户注册协议》：您与灏睿云医订立的关于您使用灏睿云医平台的协议。
        </p>
        <p>
          “灏睿云医”：指珠海灏睿科技有限公司在中国境内设立的具备资质的运营实体。在本协议中被称为“灏睿云医”或“我们”。
        </p>
        <p>
          “灏睿云医平台”：指灏睿云医网站（域名<span style="color: #0000ff"
            >hryunyi.com</span
          >）、灏睿云医、灏睿云医生等网站及客户端应用程序。
        </p>
        <p>
          “关联公司”：灏睿云医直接或间接控股的公司，参股或形成经营、协作的，具有关联关系的企业。
        </p>
        <p>“用户”：本服务的使用人，在本协议中被称为“您”或“用户”。</p>
        <p>一、总则</p>
        <p>
          1、灏睿云医平台是一个医疗健康交流互通平台，为确保您能正常地使用本服务，您应当阅读并遵守本协议。请您务必谨慎阅读、充分理解各条款内容，以及开通或使用某项服务的单独协议，并选择接受或不接受。
        </p>
        <p>
          2、除非您已阅读并接受本协议所有条款，否则您无权使用本服务。您在灏睿云医平台的登录、查看、发布信息等行为即视为您已阅读并同意本协议的约束，包括接受更新后的本协议条款。当您与灏睿云医平台发生争议时，应以最新的本协议条款为准。
        </p>
        <p>
          3、灏睿云医为您提供全面的互联网电子服务或商品，为充分保护您对于灏睿云医提供的各项服务的知情权，灏睿云医就其提供的各项服务的相关性、有效性以及限制性提供以下注册条款。灏睿云医在此特别提醒您，在您使用注册前已确实仔细阅读了本协议，如果您对本协议的任何条款或者将来随时可能修改、补充的条款有异议，您可选择不注册。
        </p>
        <p>
          4、您在进行注册程序过程中，根据声音、文字或图形等提示可以选择表示“同意”的操作，当您点选“同意”按钮时即视为您已仔细阅读本协议，同意接受本协议项下的所有条款，包括接受灏睿云医对本协议条款随时所做的任何修改，并愿意受其约束。之后方能按系统提示完成全部注册程序、问答程序、享受相关的互联网电子服务或商品。
        </p>
        <p>
          5、您在灏睿云医平台提问、搜索、提供各项电子信息、与其它用户交流及使用其他电子服务，即代表您已经同意本协议。
        </p>

        <p>
          6、本协议的条款适用于灏睿云医提供的各种服务，但当您使用灏睿云医某一特定服务时，如该服务另有单独的服务条款、指引或规则，您应遵守本协议及灏睿云医随时公布的与该服务相关的服务条款、指引或规则等。前述所有的指引和规则，均构成本协议的一部分。除非本协议另有其他明示规定，新推出的产品或服务、增加或强化目前本服务的任何新功能，均受到本协议之规范。
        </p>
        <p>二、本协议的确认和接纳</p>
        <p>
          1、灏睿云医平台的互联网电子服务或商品的所有权和运作权归灏睿云医所有。您同意所有注册协议条款并完成注册程序，才能成为灏睿云医平台的正式用户。您确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。
        </p>
        <p>
          2、您点击登录，即视为您确认自己具有享受灏睿云医平台服务、下单购买等相应的权利能力和行为能力，能够独立承担法律责任。
        </p>
        <p>
          3、如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用灏睿云医平台。
        </p>
        <p>
          4、灏睿云医保留在中华人民共和国大陆地区施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。
        </p>
        <p>
          5、灏睿云医运用自己的操作系统通过国际互联网为您提供互联网电子服务或商品，并承担本协议和其它服务协议中对您的责任和义务。为使用本服务，您必须能够自行通过有法律资格的第三方对您提供互联网接入服务，并自行承担以下内容：
        </p>
        <p>
          (1)自行配备上网所需的设备，包括个人电脑，调制解调器及其他必要的设备装置。
        </p>
        <p>(2)自行承担上网所需的相关必要费用，如：电话费用、网络费用等。</p>
        <p>(3)本协议中规定的您的其他责任和义务。</p>
        <p>
          6、您应保证：提供详尽、真实、准确和完整的个人资料以符合实名认证的要求。如果资料发生变动，您应及时更改。若您提供任何错误、不实、过时或不完整的资料，并为灏睿云医所确知，或者灏睿云医有合理理由怀疑前述资料为错误、不实、过时或不完整的资料，灏睿云医有权暂停或终止对您的帐号提供服务，并拒绝现在或将来申请使用本服务的全部或一部分的请求。在此情况下，您可通过灏睿云医的申诉途径与灏睿云医取得联系并修正个人资料，经灏睿云医核实后恢复账号使用。
        </p>
        <p>7、本服务不会提供给被暂时中止或永久终止资格的灏睿云医平台用户。</p>
        <p>三、用户依法言行义务</p>
        <p>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</p>
        <p>
          （1）不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；
        </p>
        <p>（2）从中国大陆向境外传输资料信息时必须符合中国有关法规；</p>
        <p>
          （3）不得利用灏睿云医平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；
        </p>
        <p>
          （4）不得干扰灏睿云医平台的正常运转，不得侵入灏睿云医平台及国家计算机信息系统；
        </p>
        <p>
          （5）不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料；
        </p>
        <p>
          （6）不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；
        </p>
        <p>（7）不得教唆他人从事本条所禁止的行为。</p>
        <p>四、用户管理</p>
        <p>
          1、在进行注册过程中，您的用户名注册与使用应符合网络道德，遵守中华人民共和国的相关法律法规。您的用户名和昵称中不能含有威胁、淫秽、谩骂、非法、侵害他人正当权益等有争议性的文字。您在灏睿云医平台上的言论不得违法、不得违反公序良俗、不得使用攻击性语言恶意中伤他人，或作出虚假性陈述。您保证您在灏睿云医平台上提供的信息的真实性、合法性和有效性。您单独承担在灏睿云医平台上发布内容的一切相关责任。您使用或提供的服务应遵守所有适用于灏睿云医的地方法律、国家法律和国际法律标准。
        </p>
        <p>
          2、您从中国境内向外传输技术性资料时必须符合中国有关法律法规的规定。
        </p>
        <p>3、您不得使用本服务于其他非法用途。</p>
        <p>
          4、您不得干扰或扰乱本服务，不得盗用他人帐号，如有上述行为，您需对此行为造成的后果负责。
        </p>
        <p>
          5、您应遵守所有使用本服务的各项协议、规定、程序和惯例。您须承诺不传输任何非法的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的等信息资料。另外，您也不能传输任何教唆他人构成犯罪行为的资料；不能传输助长国内不利条件和涉及国家安全的资料；不能传输任何不符合当地法规、国家法律和国际法律的资料。未经许可而非法进入其它电脑系统是禁止的。
        </p>
        <p>
          6、您不得发布任何不基于事实、虚构、夸大、引人误解的信息；不得发布涉及政治、性别、种族歧视或攻击他人的文字、图片、视频或语言等信息；不得发布介绍个人、科室等广告性质的内容；不得有其它涉及违反当地法规、国家法律和国际法律的行为。
        </p>
        <p>7、您发布的文章、视频、资讯不得侵犯任何第三方的合法知识产权。</p>
        <p>
          8、若您的行为不符合本协议的规定，灏睿云医有权做出独立判断，并立即停止向您该帐号提供服务。您需对自己在网上的行为承担法律责任。您若在灏睿云医平台上散布和传播反动、色情或其他违反国家法律的信息，灏睿云医的系统记录将作为您违反法律的证据。
        </p>
        <p>
          9、您的授权行为：对灏睿云医而言，您帐号和密码是唯一验证您真实性的依据，只要使用了正确的您帐号和密码，无论是谁登录均视为已经得到您本人的授权。
        </p>
        <p>
          10、您同意您勾选知情同意选项或采纳医生建议即视为风险提示已告知并获得您的知情同意。
        </p>
        <p>
          11、在接受互联网诊疗服务时，用户应提供相关就诊者初诊数据，并保证所提供的初诊数据的完整性、真实性、合法性和准确性。
        </p>
        <p>
          12、您的授权行为：用户同意授权灏睿云医获取患者数据，并为患者服务的目的使用所有就诊数据，包括用户在其他实体医疗机构的数据。
        </p>
        <p>
          13、根据相关法律法规规定，用户应理解互联网诊疗不涉及面诊、触诊、初诊，医生仅根据患者提供的信息和初诊数据提供复诊服务。
        </p>
        <p>五、用户责任</p>
        <p>
          1、您同意保障和维护灏睿云医的利益，如果因为您违反有关法律、法规或本协议的任何规定而给灏睿云医、医生或任何其他第三方造成任何损失，您统一承担由此产生的损害赔偿责任，其中包括但不限于灏睿云医为此而支付的律师费用。
        </p>
        <p>
          2、您同意承担包括但不限于如下违反相关法律法规或违反平台规则情形造成的全部责任：
        </p>
        <p>（1）提供信息不完整、不真实、不准确，对医生诊断产生误导影响；</p>
        <p>（2）未按要求披露过敏史等；</p>
        <p>（3）您或者您的近亲属不配合医疗机构或医生进行符合诊疗规范的诊疗；</p>
        <p>（4）以任何形式侵犯他人名誉权等行为。</p>
        <p>六、您的帐号、密码和安全性</p>
        <p>
          1、您一旦注册成功，成为灏睿云医的合法用户，将得到一个您的帐号和密码。您的帐号和密码由您负责保管。您要对任何以您帐号进行的活动和事件负全责，且您有权随时根据指示更改您的密码。若发现任何非法使用您的帐号或存在安全漏洞的情况，请立即通知灏睿云医。
        </p>
        <p>
          2、因黑客行为或您的保管疏忽等情况导致帐号、密码遭他人非法使用，灏睿云医不承担责任。灏睿云医将根据法律法规的要求，履行其作为移动互联网信息服务提供者应当履行的义务。
        </p>
        <p>七、收费服务</p>
        <p>
          1、灏睿云医平台的相关服务是以收费方式提供的，如您使用收费服务，请遵守相关的协议。2、请您在支付费用时，仔细阅读收费服务的相关协议，除协议约定的情况外，灏睿云医将不予退费。退费的方式视支付方式的不同而不同。用户应严格依据退费方式及退费周期收回退款。
        </p>
        <p>
          3、灏睿云医可能根据实际需要对收费服务的收费标准、方式进行修改和变更，灏睿云医也可能会对部分免费服务开始收费。前述修改、变更或开始收费前，灏睿云医将在相应服务页面进行通知或公告。如果您不同意上述修改、变更或付费内容，则应停止使用该服务。
        </p>
        <p>八、服务暂停、变更与中止条款</p>
        <p>
          1、鉴于移动互联网服务的特殊性，灏睿云医有权随时变更、中止或终止部分或全部的服务。如变更、中止或终止的服务属于免费服务，灏睿云医无需通知您，也无需对您或任何第三方承担任何责任。
        </p>
        <p>
          2、您理解，灏睿云医需要定期或不定期地对提供本服务的平台或相关的设备进行检修或者维护，如因此类情况而造成本服务在合理时间内的中断，灏睿云医无需为此承担任何责任，但灏睿云医应尽可能事先进行通告。
        </p>
        <p>
          3、如发生下列任何一种情形，灏睿云医有权随时中断或终止向您提供本协议项下的服务而无需对您或任何第三方承担任何责任：
        </p>
        <p>(1)您违反国家有关法律法规或灏睿云医平台规定，侵害他人合法权益的；</p>
        <p>(2)您提供的个人资料不真实；</p>
        <p>(3)您违反本协议中的规定；</p>
        <p>(4)您违反灏睿云医发布的政策；</p>
        <p>(5)灏睿云医认为其他不适宜的地方。</p>
        <p>九、结束服务</p>
        <p>
          您或灏睿云医可随时根据用户管理的规范（参见本协议的第四条）和实际情况中断一项或多项本服务，灏睿云医无需对您或任何其他第三方负责。您对本协议的修改有异议，或对灏睿云医的服务不满，可以行使如下权利：
        </p>
        <p>1、停止使用灏睿云医提供的服务。</p>
        <p>
          2、通告灏睿云医停止对该您帐号的服务。结束您的服务后，您使用本服务的权利马上终止，即刻起，灏睿云医不再对您承担任何义务和责任。
        </p>
        <p>十、隐私及个人信息的保护</p>
        <p>1、保护您隐私是灏睿云医的一项基本政策。</p>
        <p>
          2、您的信任对灏睿云医非常重要，灏睿云医深知个人信息安全的重要性，灏睿云医将按照法律法规要求，采取安全保护措施，保护您的个人信息安全。具体详见《隐私权政策》。
        </p>
        <p>十一、对第三方责任的声明</p>
        <p>
          灏睿云医因服务必要，可能会将相关网站或内容链接至灏睿云医开展合作的伙伴的网站或平台（统称“第三方网站”）。如果您使用灏睿云医提供的链接访问第三方网站，这些网站的运营商可能会收集您的个人信息。灏睿云医尽力确保所有链接的第三方网站采用同等的个人信息保护措施，但是灏睿云医不对这些第三方网站上的活动、隐私权政策或隐私保护水平承担任何法律或其他责任。
        </p>

        <p>十二、知识产权条款</p>
        <p>
          1、您一旦接受本协议，即表明您主动将您在任何时间段在灏睿云医平台发表的任何形式的信息内容（包括但不限于用户评价、用户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给灏睿云医所有，您同意灏睿云医有权就任何主体侵权而单独提起诉讼。
        </p>
        <p>
          2、本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2010年4月1日起施行的第二次修正版的《著作权法》确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在灏睿云医平台上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
        </p>
        <p>
          3、您同意并已充分了解本协议的条款，承诺不将已发表于灏睿云医平台的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。
        </p>
        <p>
          4、灏睿云医是灏睿云医平台的制作者，拥有灏睿云医平台内容及资源的著作权等合法权利，受国家法律保护，有权不时地对本协议及灏睿云医平台的内容进行修改，并在灏睿云医平台张贴，无须另行通知您。在法律允许的最大限度范围内，灏睿云医对本协议及灏睿云医平台的内容拥有解释权。
        </p>
        <p>
          5、除法律另有强制性规定外，未经灏睿云医明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用灏睿云医平台的信息内容，否则，灏睿云医有权追究其法律责任。
        </p>
        <p>
          6、灏睿云医平台所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是灏睿云医或其内容提供者的财产，受中国和国际版权法的保护。灏睿云医平台上所有内容的汇编是灏睿云医的排他财产，受中国和国际版权法的保护。灏睿云医平台上的所有软件都是灏睿云医或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
        </p>
        <p>十三、特别授权</p>
        <p>您完全理解并不可撤销地授予灏睿云医下列权利：</p>
        <p>
          1、一旦您向灏睿云医作出任何形式的承诺，且相关机构已确认您违反了该承诺，则灏睿云医有权立即按您的承诺或协议约定的方式对您的账户采取限制措施，包括中止或终止向您提供服务，并公示相关机构确认的您的违约情况。您了解并同意，灏睿云医无须就相关违约事项与您核对事实，或另行征得您的同意，且灏睿云医无须就此限制措施或公示行为向您或任何第三方承担任何的责任。
        </p>
        <p>
          2、一旦您违反本协议、或与灏睿云医签订其他协议的约定，灏睿云医有权以任何方式通知本服务或其他相关灏睿云医服务的提供方或提供平台，要求其对您的权益采取限制措施，包括但不限于要求中止、终止对您提供的部分或全部服务，且在其经营或实际控制的网站或APP公示您的违约情况。
        </p>
        <p>
          3、您授权灏睿云医使用您注册、使用本服务过程中形成的信息，并允许灏睿云医通过短信、邮件、电话或其他形式向您传送灏睿云医提供的服务。您同意接受灏睿云医通过短信、邮件、电话或其他形式向您发送活动、服务或其他相关商业信息。如果您不需要灏睿云医提供的部分或全部服务的活动、服务或其他相关商业信息的服务，在您向灏睿云医客服提出申请后予以中止、终止对您提供的该部分或全部服务。
        </p>
        <p>十四、灏睿云医拒绝提供担保</p>
        <p>
          1、您对移动网络服务的使用承担风险，并承担因为使用移动网络服务而产生的一切后果。灏睿云医对此不作任何类型的担保，不论是明确的或隐含的，但是不对商业性的隐含担保、特定目的和不违反规定的适当担保作限制。
        </p>
        <p>
          2、灏睿云医不担保本服务一定能完全满足您的要求，也不担保本服务不会受网络、通信等原因而中断，对服务的及时性、安全性、错误程序的发生都不作担保。
        </p>
        <p>
          3、灏睿云医因受合作医疗机构等资源限制，就您所提的请求不担保服务一定能够成功。
        </p>
        <p>
          4、灏睿云医对在灏睿云医平台上得到的任何有关健康的咨询意见等，不作担保。
        </p>
        <p>
          5、您不能从灏睿云医得到口头或书面的意见或信息（增加除外条款，而并非全部），灏睿云医也不会在此做明确担保。
        </p>
        <p>
          6、除非另有明确的书面说明，灏睿云医平台及其所包含的或以其它方式通过灏睿云医平台提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在“按现状”和“按现有”的基础上提供的。除非另有明确的书面说明，灏睿云医不对灏睿云医平台的运营及其包含在灏睿云医平台上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的除外）。<br />7、灏睿云医不担保灏睿云医平台包含的或以其它方式通过灏睿云医平台提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从灏睿云医平台发出的电子信件、信息没有病毒或其他有害成分。如因不可抗力或其它灏睿云医平台无法控制的原因使灏睿云医平台系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，灏睿云医会合理地尽力协助处理善后事宜。<br />8、灏睿云医平台所承载的内容（文、图、视频、音频）均为传播有益健康资讯目的，不对其真实性、科学性、严肃性做任何形式保证。
        </p>
        <p>十五、责任限制</p>
        <p>
          1、灏睿云医平台服务是按照现有技术和条件所能达到的水平提供的服务。灏睿云医会尽最大努力为您提供服务，确保服务的连贯性和安全性；但灏睿云医不能随时预见和防范法律、技术以及其他风险，包括但不限于不可抗力、病毒、木马、黑客攻击、系统不稳定、第三方服务瑕疵、政府行为等原因可能导致的服务中断、数据丢失以及其他的损失和风险。灏睿云医所不能控制的事件而影响灏睿云医提供服务，灏睿云医无须承担任何责任。
        </p>
        <p>
          2、灏睿云医对您使用网络服务而受到的任何直接、间接、偶然、特殊及继起的损害（灏睿云医违反法律、法规和本协议的条款除外）不负责任，这些损害可能来自：不正当使用网络服务，私自在网上进行交易，非法使用网络服务或您传送的信息有所变动。这些行为都有可能会导致灏睿云医的形象受损，所以灏睿云医事先提出这种损害的可能性。
        </p>
        <p>
          3、灏睿云医所有信息仅供参考。灏睿云医致力于提供正确、完整的健康资讯，但不保证信息的绝对正确性和完整性，且不对因信息的不正确或遗漏导致的任何损失或损害承担责任。灏睿云医所提供的任何健康资讯，仅供参考，不能替代医生和其他医务人员的建议，如自行使用灏睿云医资料发生偏差，灏睿云医不承担任何法律责任。
        </p>
        <p>
          4、因医生的诊疗行为产生的医疗责任由医生承担，国家法律法规政策对此有规定的，以规定为准。
        </p>
        <p>5、灏睿云医拒绝回复的问题，包括但不限于如下情况：</p>
        <p>
          （1）各项非互联网医疗服务类问题，如动物疾病问题、社会意识形态问题等；
        </p>
        <p>（2）医疗司法举证或询证问题；</p>
        <p>（3）胎儿性别鉴定问题；</p>
        <p>（4）未按提问要求提问，如提问时未指定医生，却要求具体医生回复；</p>
        <p>（5）有危害他人/自己可能的问题；</p>
        <p>（6）追问医生个人信息的问题；</p>
        <p>（7）故意挑逗、侮辱医生的提问。</p>
        <p>
          6、灏睿云医平台所提供的任何各项电子信息、症状自查等服务仅供参考，如自行使用灏睿云医平台中资料发生偏差，灏睿云医概不负责，亦不负任何法律责任。
        </p>
        <p>7、灏睿云医保留对本声明作出不定时修改的权利。</p>
        <p>
          8、灏睿云医不对您所发布信息的删除或储存失败负责。灏睿云医积极采用数据备份加密等措施保障您数据的安全，但不对由于因意外因素导致的数据损失和泄漏负责。灏睿云医有权审查和监督您的行为是否符合本协议的要求，如果您违背了本协议的约定，则灏睿云医有权中断您的服务。
        </p>
        <p>9、您同意因下列情形之一的，灏睿云医不承担赔偿责任：</p>
        <p>（1）患者或者其近亲属不配合进行符合诊疗规范的诊疗；</p>
        <p>（2）医务人员在紧急情况下已经尽到合理诊疗义务；</p>
        <p>（3）限于当时的医疗水平难以诊疗。</p>
        <p>
          10、如果您或第三方就相关服务购买了保险，因发生保险事故导致损失的，保险公司已经向您或第三方承担或许诺承担保险理赔责任后，灏睿云医在此范围内不再承担赔偿责任。
        </p>
        <p>十六、广告说明</p>
        <p>
          1、灏睿云医平台上为您的便利而提供的外部链接，包括但不限于任何广告内容链接，以及该链接所指向网页之所有内容，均系该网页所属第三方的所有者制作和提供（以下简称“第三方网页”）。第三方网页并非也不反映灏睿云医之任何意见和主张，也不表示灏睿云医同意或支持该第三方网页上的任何内容、主张或立场。灏睿云医对第三方网页中内容之合法性、准确性、真实性、适用性、安全性和完整性等概不承担任何责任。任何单位或个人如需要第三方网页中内容（包括资讯、资料、消息、产品或服务介绍、报价等），并欲据此进行交易或其他行为前，应慎重辨别这些内容的合法性、准确性、真实性、适用性、完整性和安全性（包括下载第三方网页中内容是否会感染电脑病毒），并采取谨慎的预防措施。如您不确定这些内容是否合法、准确、真实、实用、完整和安全，建议您先咨询专业人士。
        </p>
        <p>
          2、任何单位或者个人因相信、使用第三方网页中信息、服务、产品等内容，或据此进行交易等行为，而引致的人身伤亡、财产毁损（包括因下载而感染电脑病毒）、名誉或商誉诽谤、版权或知识产权等权利的侵犯等事件，及因该等事件所造成的损害后果，灏睿云医概不承担任何法律责任。无论何种原因，灏睿云医不对任何非与灏睿云医直接发生的交易和行为承担任何直接、间接、附带或衍生的损失和责任。
        </p>
        <p>十七、协议修改</p>
        <p>
          根据国家法律法规变化及网络运营需要，灏睿云医有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在灏睿云医平台上即生效，并代替原来的协议，灏睿云医将公告通知变更信息。您可随时登陆查阅最新协议；您有义务不时关注并阅读最新版的协议及灏睿云医平台公告。如您不同意更新后的协议，可以且应立即停止接受灏睿云医平台依据本协议提供的服务；如您继续使用灏睿云医平台提供的服务，即视为同意更新后的协议。灏睿云医建议您在使用灏睿云医平台之前阅读本协议及灏睿云医平台的公告。如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。当发生有关争议时，以最新的协议条款为准。
        </p>
        <p>十八、通告</p>
        <p>
          1.本协议项下所有的通知均可通过重要页面公告、电子邮件或常规的信件传送等方式进行；该等通知于发送之日视为已送达。
        </p>
        <p>
          2.您对于灏睿云医的通知应当通过灏睿云医平台对外正式公布的通信地址、电子邮件地址等联系信息进行邮寄书面送达。
        </p>
        <p>十九、法律管辖和适用</p>
        <p>1、本协议签订于中华人民共和国广东省珠海市香洲区。</p>
        <p>
          2、本协议之效力、解释、执行和争议的解决均适用中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。
        </p>
        <p>
          3、如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方可提交本协议签订地有管辖权的人民法院诉讼裁决。
        </p>
        <p>二十、其他</p>
        <p>
          1、灏睿云医尊重您的合法权利，本协议及灏睿云医平台上发布的各类规则、声明等其他内容，均是为了更好地、更加便利地为您提供服务。灏睿云医平台欢迎您和社会各界提出意见和建议，灏睿云医将虚心接受并适时修改本协议及灏睿云医平台的各类规则。
        </p>
        <p>
          2、本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请您着重阅读。
        </p>
        <p>
          3、您注册使用灏睿云医平台即视为您完全接受本协议，在点击“登录”之前请您再次确认已知悉并完全理解本协议的全部内容。
        </p>
      </div>
    </div>
    <div v-else-if="type == '1'">
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">隐私权政策</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: right;
          widows: 0;
        "
      >
        <span style="font-size: 16px">隐私权政策</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: right;
          widows: 0;
        "
      >
        <span style="font-size: 16px">最近更新日期：</span
        ><span style="color: #0000ff; font-size: 16px">2020年06月30日</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >您的信任对我们非常重要，我们深知个人信息安全的重要性，我们将会按照法律法规要求，采取安全保护措施保护您的个人信息安全
          。鉴此，</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >服务提供者（或简称“我们”）制定本《隐私权政策》并提醒您：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">本政策适用于</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的各项服务或产品。如我们及/或关联公司（范围详见定义部分）的服务或产品中使用了</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">提供的服务或产品（例如直接使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >账户登录）但未设独立隐私权政策的，则本政策同样适用于该部分服务或产品。我们及/或关联公司就其向您提供的产品或服务单独设立隐私权政策的，则相应产品或服务适用该相应的隐私权政策。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请您注意，本政策不适用由其他公司或个人（以下简称“第三方”）提供的服务。如您使用该等第三方服务须受该第三方隐私政策（而非本政策）约束，您需要仔细阅读其政策内容。我们不参与且不对您与第三方之间因个人信息保护等发生的纠纷承担任何责任。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">请您在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >各项服务或产品前，务必仔细阅读并透彻理解本政策，特别是以粗体标识的条款，您应重点阅读，在确认充分理解并同意后再开始使用。在任何情况下，您的使用行为将被视为对本政策全部内容的认可。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如您对本政策内容有任何疑问、意见或建议，您可通过本政策提供的各种联系方式与我们联系。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">第一部分 定义</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">：指</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">网站（域名为</span
        ><span style="color: #0000ff; font-size: 16px"
          >https://zhhaorui.com</span
        ><span style="font-size: 16px">）、</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">客户端、</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">公众号以及</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">小程序等。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">服务提供者：指</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">的软件技术服务提供者</span
        ><span style="color: #0000ff; font-size: 16px"
          >珠海灏睿科技有限公司。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">用户：指</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >产品或服务的使用人，在本政策中被称为“您”或“用户”。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >个人信息：指以电子或者其他方式记录的能够单独或者与其他信息结合识别特定自然人身份或者反映特定自然人活动情况的各种信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >个人敏感信息：指包括身份证件号码、个人生物识别信息、银行账号、财产信息、行踪轨迹、交易信息、14岁以下（含）儿童信息等的个人信息（我们将在本隐私权政策中对具体个人敏感信息以粗体进行显著标识）。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >个人信息删除：指在实现日常业务功能所涉及的系统中去除个人信息的行为，使其保持不可被检索、访问的状态。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">儿童：指不满十四周岁的未成年人。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">第二部分 隐私权政策</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >本隐私权政策部分将帮助您了解以下内容：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">一、我们如何收集和使用您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">二、我们如何使用</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">Cookie</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">和同类技术</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >三、我们如何共享、转让、公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">四、我们如何保护您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">五、您如何管理您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">六、我们如何处理未成年人的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">七、您的个人信息如何在全球范围转移</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">八、本政策如何更新</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">九、如何联系我们</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">一、我们如何收集和使用您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >我们会为实现本政策所述的以下功能，收集和使用您的个人信息：</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica">（一）为您提供注册与认证功能</span>
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >您需要注册一个账户，以便于我们为您提供服务。当您注册时，请您至少提供<span
            class="boldFont"
            >手机号码、密码</span
          >，我们将通过发送短信验证码的方式验证您的身份是否有效。如果您仅需使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >您的登录名可以是您的<span class="boldFont"
            >手机号、邮箱账号、用户名</span
          >，您可以完善<span class="boldFont"
            >昵称、密码、头像、联系地址、出生日期</span
          >等相关信息。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >您可能需要根据灏睿云医页面提示向我们提供<span class="boldFont"
            >真实姓名</span
          >和<span class="boldFont">有效身份证件（如身份证、医保卡、护照）</span
          >的号码和复印件、<span class="boldFont">生物识别特征</span
          >（静态或动态的面部特征），以便于我们进行实名（实人）认证。如果您不提供这些信息，可能会影响您对灏睿云医部分核心业务功能的正常使用，如预约挂号等，但不会影响您进行基本的浏览、搜索。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >如成为灏睿云医平台的注册医生，您需要提供<span class="boldFont"
            >手机号码、邮箱账号、用户名，并创建密码</span
          >等。在注册过程中，如您提供以下额外信息，将有助于我们对您提供电子服务资格进行认证：您的真实姓名、性别、身份证正反面照片、<span
            class="boldFont"
            >联系信息（QQ/微信/邮箱地址）、医院电话、执业医师资格证、医师执业证书、职称证、您本人的真实头像</span
          >。如果您未提供这些信息，将会影响到您在灏睿云医进行的电子服务活动。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >授权登录：您注册灏睿云医账户后，我们可能经您同意后向我们的关联公司共享您的账户信息（头像、昵称及其他页面提示的信息），您可通过同一账号在我们提供的链接入口使用我们关联公司提供的服务或产品。此外，我们可能从第三方获取您授权共享的第三方账户信息（如头像、昵称、联系方式等），并将您的第三方账户与您的灏睿云医账户绑定，使您可以通过第三方账户直接登录并使用灏睿云医的服务或产品。我们将依据与第三方的约定、对个人信息来源的合法性进行确认后，在符合相关法律和法规规定的前提下，使用您的这些个人信息。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >（二）为您提供问诊、健康咨询功能</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >当您使用灏睿云医的产品或服务提供的问诊功能，在问诊过程中，我们可能会申请开启您的<span
            class="boldFont"
            >位置信息（地理位置）</span
          >、相机/摄像头、麦克风（语音）、通讯录以及存储的相关权限；同时可能要求您提供病症、住院志、医嘱单、检验报告、手术及麻醉记录、护理记录、用药记录、药物食物过敏信息、生育信息、以往病史、诊治情况、家族病史、现病史、传染病史及其他个人健康生理信息，以及个人身体健康状况产生的体重、身高、肺活量和其他相关信息，用于患者病情的诊断。另外，我们可能会收集您在使用灏睿云医服务或产品过程中产生的健康咨询详情（如图片、文字、视频、语音）、预约挂号记录、检查检验、用药处方、医生诊断结果等信息，用于向您展示及便于您对信息进行管理。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >您可以通过灏睿云医为其他人进行预约或咨询等服务，您需要提供该实际用户的前述个人信息。在提供该实际用户的前述个人信息之前，您需确保您已经取得其授权同意，其中涉及儿童个人信息的，您需在提供前征得该儿童监护人的同意。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica">（三）为您提供购物功能</span>
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >当您在灏睿云医的产品及/或服务中订购相应的医疗服务和健康商城商品或服务时，我们可能会收集您的交易信息、记录，包括您所购买的<span
            class="boldFont"
            >商品及/或服务信息</span
          >、具体订单号、订单创建时间、您应支付的金额，我们收集这些信息是为了帮助您顺利完成交易、保障您的交易安全、查询订单信息。其中，如您购买健康商城商品的，在下单过程中,您需至少提供您的<span
            class="boldFont"
            >收货人姓名、收货地址、收货人联系电话</span
          >；您可以通过健康商城为其他人订购商品及/或服务，但需提供该实际收货人的前述个人信息，且需确保您已经取得其授权同意。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica">（四）帮助您完成支付</span>
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >为完成您所订购的相应医疗服务和/或药品费用的支付，您需要提供<span
            class="boldFont"
            >银行卡号、身份证号码、银行卡的预留手机号和/或其他认证信息、创建账户与支付口令、医保卡号、医保卡绑定的手机号码以及医保支付口令</span
          >，同时，为满足相关法律法规或监管机构的要求，我们可能需要将您必要的<span
            class="boldFont"
            >个人信息及上述支付信息</span
          >提供给监管机构以及监管机构指定的第三方服务机构，以顺利完成您所订购相应医疗服务和药品费用的支付和结算。如您不提供上述信息将无法正常使用医保支付功能。为完成您所订购的其他商品或服务的支付，您需要提供<span
            class="boldFont"
            >银行卡号、该卡的预留手机号、身份证号码，并创建账户与支付口令</span
          >。如您不提供上述信息，将无法正常使用相关的支付功能，但不影响您使用灏睿云医产品或服务的基本浏览、搜索功能。</span
        >
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica">（五）完成商品或服务的交付</span>
      </p>
      <p style="margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica"
          >为便于向您交付您在灏睿云医的产品或服务中订购的具体商品/服务，您需提供<span
            class="boldFont"
            >收货人姓名、收货地址、邮政编码、收货人联系电话</span
          >。如果我们委托第三方向您交付时，我们会在征得您同意后将上述信息共享给第三方。如果您拒绝提供此类信息，您理解并同意我们将无法完成相关交付商品或服务。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（六）为您提供客户服务</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >当您与我们联系时，我们可能会保存您的通信/通话记录和内容或您留下的联系方式等信息，以便与您联系或帮助您解决问题，或记录相关问题的处理方案及结果。为了提供服务及改进服务质量的合理需要，我们还可能使用的您的其他信息，包括您与客服联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（七）为您提供评价、问答等信息公开发布功能</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">您</span
        ><span style="font-size: 16px">可</span
        ><span style="font-size: 16px"
          >通过我们为您提供的评价、问答、论坛等信息发布功能公开发布信息，包括作为注册用户可发表评价及问答内容、发布图文信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请注意，您公开发布的信息中可能会涉及您或他人的个人信息甚至个人敏感信息，如您在评价时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的服务时共享甚至公开分享相关信息。若您公开发布的信息中涉及儿童个人信息的，您需在发布前征得对应儿童监护人的同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（八）为您提供安全保障</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请注意，为确保账户身份真实性、向您提供更好的安全保障，您可以向我们提供姓名和身份证号完成实名认证、也可通过绑定银行卡的方式完成实名认证。如拒绝完成实名认证服务，您可能无法使用特定的服务或产品，但不会影响您使用浏览、搜索等服务。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="color: #0000ff; font-size: 16px"
          >为提高您使用我们及我们关联公司</span
        ><span style="font-size: 16px"
          >、合作伙伴提供服务的安全性，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >相关协议规则的情况，我们可能使用或整合您的账户信息、交易信息、设备信息、有关网络日志以及我们关联公司、合作伙伴取得您授权或依据法律共享的信息，来综合判断您账户及交易风险、进行身份验证、检测及防范安全事件，并依法采取必要的记录、审计、分析、处置措施。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（九）设备权限调用</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >为向您提供便捷、优质的服务，我们可能会调用您设备的一些权限，以下是我们可能调用的设备权限列表及对应的使用目的说明，您有权随时选择关闭下列权限的授权，但可能会影响您正常使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">服务或产品的部分或全部功能。</span>
      </p>
      <p style="margin-top: 0pt; margin-bottom: 10pt; text-align: justify">
        <span style="font-family: Helvetica; font-size: 16px"
          >为提升消息的送达率，及时地为您进行消息提醒，我们会默认为您开启关联启动功能，以保持应用的活跃度如您不想开通此功能，我们建议您手动进行关闭，一般关闭路径:设置
          - 应用 - 应用启动管理- 选择应用“灏睿云医”- 关闭关联启动功能</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0pt; width: 100%"
      >
        <thead>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">设备权限</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">对应业务功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">调用权限的目的</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是否询问</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">可否关闭权限</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >如果关闭权限会影响用户什么功能</span
                >
              </p>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">位置</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用于基于位置的药店、医院信息展示、推送</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >通过用户当前位置，优化用户搜索等信息展示</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK49"
                  ><span style="font-size: 16px"
                    >用户首次打开移动客户端时会弹窗询问</span
                  ></a
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户将无法准确使用基于位置的医疗信息展示</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">通讯录</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">电话问诊</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">为保护医患双方个人信息安全，</span
                ><span style="font-size: 16px">灏睿云医</span
                ><span style="font-size: 16px"
                  >将在通讯录中写入一个中转电话，避免双方联系方式泄露</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK51"
                  ><span style="font-size: 16px"
                    >用户首次打开手机客户端时会弹窗询问</span
                  ></a
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户可能无法正常在视话问诊时使用电话申请功能</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">相机</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">核心业务功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">1、问诊时拍摄并上传照片</span>
              </p>
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">2、视频问诊</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK53"
                  ><span style="font-size: 16px"
                    >用户使用相应服务前会弹窗询问</span
                  ></a
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户无法正常使用视频问诊功能</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">通知</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">全部功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >接受问诊、支付结果、患者问诊等各类消息</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开手机客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">用户无法正常</span
                ><span style="font-size: 16px">接受</span
                ><span style="font-size: 16px"
                  >各类消息，无法及时获知预约挂号、患者问诊等提醒等</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">无线数据</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">全部功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">连接网络</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开手机客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">WLAN</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">全部功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK58"
                  ><span style="font-size: 16px">连接网络</span></a
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开手机客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 24.75pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">存储</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">全部功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >写入存储用户信息，存储日志等信息</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开手机客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK60"
                  ><span style="font-size: 16px"
                    >移动客户端无法正常使用</span
                  ></a
                >
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">麦克风</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">核心业务功能</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">视频问诊</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户使用相应服务前会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <a name="OLE_LINK56"></a
                ><a name="OLE_LINK55"
                  ><span style="font-size: 16px">是</span></a
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >医患双方在视频问诊时无法正常交流</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">电话</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">安全保障</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >读取本机识别码，用于保障您的账号及使用安全</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开手机客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >您的设备与账号可能处于风险之中，但不影响主要功能。</span
                >
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">IMSI</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">一键登录</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >[一键登录、阿里云号码认证]SDK需要，用于用户一键登录</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开移动客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">IMEI</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">一键登录</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >[一键登录、阿里云号码认证]SDK需要，用于用户一键登录</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开移动客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">ANDROID ID</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">一键登录</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >[一键登录、阿里云号码认证]SDK需要，用于用户一键登录</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开移动客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">软件安装列表</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">消息推送</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">[极光]SDK需要，用于消息推送</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开移动客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
          <tr style="height: 37.5pt">
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">MAC地址</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">消息推送</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">[极光]SDK需要，用于消息推送</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px"
                  >用户首次打开移动客户端时会弹窗询问</span
                >
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">是</span>
              </p>
            </td>
            <td
              style="
                border-bottom-color: #d9d9d9;
                border-bottom-style: solid;
                border-bottom-width: 0.75pt;
                border-left-color: #d9d9d9;
                border-left-style: solid;
                border-left-width: 0.75pt;
                border-right-color: #d9d9d9;
                border-right-style: solid;
                border-right-width: 0.75pt;
                border-top-color: #d9d9d9;
                border-top-style: solid;
                border-top-width: 0.75pt;
                padding: 2.62pt 5.62pt;
                vertical-align: top;
              "
            >
              <p
                style="
                  font-size: 16px;
                  line-height: 115%;
                  margin: 0pt 0pt 10pt;
                  orphans: 0;
                  text-align: justify;
                  widows: 0;
                "
              >
                <span style="font-size: 16px">移动客户端无法正常使用</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（十一）其他</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、若您提供的信息中含有其他用户的个人信息，在向我们提供这些个人信息之前，您需确保您已经取得合法的授权。若其中涉及儿童个人信息的，您需在发布前取得对应儿童监护人的同意，前述情形下监护人有权通过本政策规定的途径联系我们，要求更正或删除涉及儿童个人信息的内容。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、我们将信息用于本政策未载明的其他用途，或者将基于特定目的收集而来的信息用于其他目的时，会事先征求您的同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">3、征得授权同意的例外</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（1）与国家安全、国防安全有关的；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（2）与公共安全、公共卫生、重大公共利益有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（3）与犯罪侦查、起诉、审判和判决执行等有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（4）出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（5）所收集的个人信息是您自行向社会公众公开的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（6）从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（7）根据您的要求签订合同所必需的；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（8）用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（9）为合法的新闻报道所必需的；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（10）学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（11）法律法规规定的其他情形。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请知悉，根据适用的法律，若我们对个人信息采取技术措施和其他必要措施进行处理，使得数据接收方无法重新识别特定个人且不能复原，或我们可能会对收集的信息进行去标识化地研究、统计分析和预测，用于改善</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >平台的内容和布局，为商业决策提供产品或服务支撑，以及改进</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的产品和服务（包括使用匿名数据进行机器学习或模型算法训练），则此类处理后数据的使用无需另行向您通知并征得您的同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">4、如我们停止运营</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >，我们将及时停止继续收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">二、我们如何使用</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">和同类技术</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（一）</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">为确保</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的正常运转，我们会在您的计算机或移动设备上存储名为</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">的小数据文件。</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px"
          >通常包含标识符、站点名称以及一些号码和字符。</span
        >
      </p>
      <!-- <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">您可根据自己的偏好管理或删除</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="font-size: 16px">。有关详情，请参见</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">AboutCookies.org</span
        ><span style="font-size: 16px">。您可以清除计算机上保存的所有</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="font-size: 16px">，大部分网络浏览器都设有阻止</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">Cookie</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px"
          >的功能。但如果您这么做，则需要在每一次访问</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >平台时更改用户设置。如需详细了解如何更改浏览器设置，请访问您使用的浏览器的相关设置页面。</span
        >
      </p> -->
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（二）网站信标和像素标签</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">除</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px">Cookie</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">外，我们还会在</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >上使用平台信标和像素标签等其他同类技术。例如，我们向您发送的电子邮件可能含有链接至</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >内容的地址链接，网站信标通常是一种嵌入到网站或电子邮件中的透明图像。借助于电子邮件中的像素标签，我们能够获知电子邮件是否被打开。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >三、我们如何共享、转让、公开披露您的个人信息</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如果为了向您提供服务而需要将您的信息共享至第三方，我们将评估该第三方收集信息的合法性、正当性、必要性。我们将要求第三方对您的信息采取保护措施并且严格遵守相关法律法规与监管要求。另外，我们会按照法律法规及国家标准的要求以确认协议、具体场景下的文案确认、弹窗提示等形式征得您的同意或确认第三方已经征得您的同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（一）共享</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">我们不会与</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >服务提供者以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">3、与关联公司间共享：为便于我们基于</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >账号向您提供服务保护本政策所定义的关联公司或其他用户或公众的人身财产安全免遭侵害，您的个人信息可能会与关联公司共享。我们只会共享必要的个人信息（如为便于您通过同一账号使用我们关联公司产品或服务，我们会向关联公司共享您必要的账户信息），如果我们共享您的个人敏感信息或关联公司改变个人信息的使用及处理目的，将再次征求您的授权同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >4、与授权合作伙伴共享：仅为实现本政策中声明的目的，我们的某些服务将由授权合作伙伴提供。我们可能会与合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。例如，在您订购我们的商品时，我们必须与物流服务提供商共享您的订单信息才能安排送货；或者我们需要将您的订单号和订单金额与金融机构共享以实现其确认您的支付指令并完成支付等。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。我们的合作伙伴无权将共享的个人信息用于任何其他用途。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >目前，我们的授权合作伙伴包括以下类型：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">(</span
        ><span style="font-size: 16px">1</span
        ><span style="font-size: 16px">）</span
        ><span style="font-size: 16px"
          >广告、分析服务类的授权合作伙伴。除非得到您的许可，否则我们不会将您的个人身份信息（指可以识别您身份的信息，例如姓名或电子邮箱，通过这些信息可以联系到您或识别您的身份）与提供广告、分析服务的合作伙伴分享。我们会向这些合作伙伴提供有关其广告覆盖面和有效性的信息，而不会提供您的个人身份信息，或者我们将这些信息进行汇总，以便它不会识别您。例如，只有在广告主同意遵守我们的广告发布准则后，我们才可能会告诉广告主他们广告的效果如何，或者有多少人看了他们广告或在看到广告后安装了应用，或者向这些合作伙伴提供不能识别个人身份的人口统计信息（例如“位于北京的25岁男性，喜欢软件开发”），帮助他们了解其受众或顾客。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">(</span
        ><span style="font-size: 16px">2</span
        ><span style="font-size: 16px">）</span
        ><span style="font-size: 16px"
          >供应商、服务提供商和其他合作伙伴。我们将信息发送给支持我们业务的供应商、服务提供商和其他合作伙伴，这些支持包括提供技术基础设施服务、安全保障服务、分析我们服务的使用方式、衡量广告和服务的有效性、提供客户服务、支付便利或进行学术研究和调查。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >为了使您能够使用本政策项下的各项服务及功能，我们的应用中会嵌入授权合作伙伴的SDK或其他类似的应用程序，其中可能会涉及传输相关个人信息，具体如下：</span
        >
      </p>
      <table
        cellspacing="0"
        cellpadding="0"
        style="border-collapse: collapse; margin-left: 0pt"
      >
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">功能类型</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK名称</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">业务场景</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人信息类型</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人信息字段</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">数据是否去标识化传输</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            rowspan="3"
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">第三方登录及分享</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">微信</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">第三方登录及分享</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">QQ登陆</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">第三方登陆及分享</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">新浪微博</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">第三方登陆及分享</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            rowspan="3"
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">支付</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">微信</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">订单支付</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">支付宝</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">订单支付</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">天津银海金医宝支付</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px"
                >SDK（包含百度地图、阿里人脸、阿里支付、银联支付）</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">订单医保支付</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人身份信息、个人基本资料、个人位置信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人姓名、个人电话号码、身份证号码、面部识别特征、定位信息、设备信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">否</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">定位及地图</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">百度地图</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
              <span style="font-size: 16px">、</span>
              <span style="font-size: 16px">高德地图</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">定位及导航</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人位置信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息、定位信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            rowspan="2"
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">账户安全</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">极验</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">保障账户安全，防范业务风险</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">同盾</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >保障账户系统安全，防范业务风险</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人位置信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息、定位信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">实名认证</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">百度人脸识别</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >实人认证（您的面部特征数据仅会加密传输至</span
              ><span style="font-size: 16px">灏睿云医</span
              ><span style="font-size: 16px"
                >服务器进行核验，不会分享至百度等第三方）</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人生物识别信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息、面部特征</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">否</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            rowspan="3"
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">系统运营</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">腾讯</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">Bugly SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">系统异常上报</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">百度统计</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">运营统计</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">友盟移动统计</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">运营统计，崩溃分析</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">语音识别</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">百度语音</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">输入辅助，在AI</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">导诊台实现语音输入、语义识别</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人通信信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">音频信息、设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">消息推送</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个推</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">推送系统通知或重要消息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">个人常用设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">视频语音</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">声网</span
              ><span style="font-size: 16px">&#xa0;</span
              ><span style="font-size: 16px">SDK</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >应用功能，视频语音通话进行就诊看诊</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >个人常用设备信息、个人通信信息</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">音频信息、视频信息、设备信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
        <tr style="height: 24.65pt">
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.82%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">浏览服务</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 21.52%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px"
                >腾讯浏览服务（com.tencent.smtt</span
              >
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 20.5%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">移动阅片功能，打开dicom文件</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 14.3%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">未获取个人信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 15.6%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">未获取个人信息</span>
            </p>
          </td>
          <td
            style="
              border-bottom-color: #d9d9d9;
              border-bottom-style: solid;
              border-bottom-width: 0.75pt;
              border-left-color: #d9d9d9;
              border-left-style: solid;
              border-left-width: 0.75pt;
              border-right-color: #d9d9d9;
              border-right-style: solid;
              border-right-width: 0.75pt;
              border-top-color: #d9d9d9;
              border-top-style: solid;
              border-top-width: 0.75pt;
              padding: 2.62pt 5.62pt;
              vertical-align: top;
              width: 12.2%;
            "
          >
            <p
              style="
                margin: 0pt 0pt 10pt;
                orphans: 0;
                text-align: justify;
                widows: 0;
              "
            >
              <span style="font-size: 16px">是</span>
            </p>
          </td>
        </tr>
      </table>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >我们会对授权合作伙伴获取有关信息的应用程序接口（API）、软件工具开发包（SDK）进行严格的安全检测，并与授权合作伙伴约定严格的数据保护措施，令其按照我们的委托目的、服务说明、本隐私权政策以及其他任何相关的保密和安全措施来处理个人信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（二）转让</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他</span
        ><span style="font-size: 16px">方</span
        ><span style="font-size: 16px">转让您的个人信息；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">2、在</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（三）公开披露</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >我们仅会在以下情况下，公开披露您的个人信息：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、获得您明确同意或基于您的主动选择，我们可能会公开披露您的个人信息；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、如果我们确定您出现违反法律法规或严重违反</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >相关协议规则的情况，或为保护我们及其关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >已对您采取的措施。例如，若您囤积号源、虚假预约而严重违反用户协议，我们可能会公开披露或与合作方共享您的身份信息、联系方式与处罚情况。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">1、与国家安全、国防安全有关的；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、与公共安全、公共卫生、重大公共利益有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >3、与犯罪侦查、起诉、审判和判决执行等有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >4、出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">5、您自行向社会公众公开的个人信息；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >6、从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">四、我们如何保护您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（一）我们已采取符合业界标准、合理可行的安全防护措施保护您提供的个人信息安全，防止个人信息遭到未经授权访问、公开披露、使用、修改、损坏或丢失。例如，在您的浏览器与服务器之间交换数据（如信用卡信息）时受</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="color: #0000ff; font-size: 16px"
          >SSL（Secure Socket Layer）</span
        ><span style="font-size: 16px">协议加密保护；我们同时对</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">平台提供</span
        ><span style="color: #0000ff; font-size: 16px"
          >HTTPS（Hyper Text Transfer Protocol over Secure Socket Layer）</span
        ><span style="font-size: 16px"
          >协议安全浏览方式；我们会使用加密技术提高个人信息的安全性；我们会使用受信赖的保护机制防止个人信息遭到恶意攻击；我们会部署访问控制机制，尽力确保只有授权人员才可访问个人信息；我们设立了个人信息保护责任部门，针对个人信息收集、使用、共享、委托处理等开展个人信息安全影响评估。同时，我们建立了相关内控制度，对可能接触到您的信息的工作人员采取最小够用授权原则；对工作人员处理您的信息的行为进行系统监控，不断对工作人员培训相关法律法规及隐私安全准则和安全意识强化宣导。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（二）我们有行业先进的以数据为核心，围绕数据生命周期进行的数据安全管理体系，从组织建设、制度设计、人员管理、产品技术等方面多维度提升整个系统的安全性。目前，我们的重要信息系统已经通过信息安全等级保护（三级）测评和</span
        ><span style="color: #0000ff; font-size: 16px">ISO27001</span
        ><span style="font-size: 16px">认证。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（三）我们会采取合理可行的措施，尽力避免收集无关的个人信息。我们依照法律法规规定，将在境内运营过程中收集和产生的您的个人信息存储在境内安全可信的服务器上；同时，超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（四）互联网并非绝对安全的环境，我们强烈建议您不要使用非</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >推荐的通信方式发送个人信息。您可以通过我们的服务建立联系和相互分享。当您通过我们的服务创建交流、交易或分享时，您可以自主选择沟通、交易或分享的对象，作为能够看到您的交易内容、联络方式、交流信息或分享内容等相关信息的第三方。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >进行网上健康咨询时，您不可避免地要向医务人员或客服披露自己的个人信息，如联系方式或身份信息。请您妥善保护自己的个人信息，仅在必要的情形下向他人提供。如您发现自己的个人信息尤其是您的账户或密码发生泄露，请您立即联络客服，以便我们根据您的申请采取相应措施。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">请注意，您在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >服务时自愿共享甚至公开分享的信息，可能会涉及您或他人的个人信息甚至个人敏感信息，如您在发帖、评论时选择上传包含个人信息的图片。请您更加谨慎地考虑，是否在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">的服务时共享甚至公开分享相关信息。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请使用复杂密码，协助我们保证您的账号安全。我们将尽力保障您发送给我们的任何信息的安全性。如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（五）我们将不定期更新并公开安全风险、个人信息安全影响评估报告等有关内容，您可通过</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">公告方式获得。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。事件相关情况我们将以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >（七）我们还将按照监管部门要求，上报个人信息安全事件的处置情况。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">五、您如何管理您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >您可以通过以下方式访问及管理您的个人信息：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（一）访问您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >您有权访问您的个人信息，法律法规规定的例外情况除外。您可以通过以下方式自行访问您的个人信息：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >账户信息——如果您希望访问或编辑您的账户中的个人基本资料信息和实名认证信息、更改您的密码或添加绑定邮箱等，您可以登录账号通过“</span
        ><span style="color: #0000ff; font-size: 16px">我</span
        ><span style="color: #0000ff; font-size: 16px">-</span
        ><span style="color: #0000ff; font-size: 16px">设置</span
        ><span style="color: #0000ff; font-size: 16px">-</span
        ><span style="color: #0000ff; font-size: 16px">账号设置</span
        ><span style="font-size: 16px">”执行此类操作。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">电子病历信息：您可以在</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">APP “</span
        ><span style="color: #0000ff; font-size: 16px">我</span
        ><span style="color: #0000ff; font-size: 16px">-</span
        ><span style="color: #0000ff; font-size: 16px">电子病历</span
        ><span style="font-size: 16px">”中新增、查阅、删除您的病历信息。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">银行卡管理：您可以登陆账号，通过“</span
        ><span style="color: #0000ff; font-size: 16px">我</span
        ><span style="color: #0000ff; font-size: 16px">-</span
        ><span style="color: #0000ff; font-size: 16px">钱包</span
        ><span style="font-size: 16px">”进行银行卡的解绑、绑定。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >预约、问诊、购药记录：您可以登陆账号，通过“我”查看了解历史记录。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如果您无法通过上述路径访问该等个人信息，您可以随时通过客服中心与我们取得联系。我们将在</span
        ><span style="color: #0000ff; font-size: 16px">15</span
        ><span style="font-size: 16px">个工作日内回复您的访问请求。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">对于您在使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的服务或产品过程中产生的其他个人信息，我们将根据本条“响应您的上述请求”中的相关安排向您提供。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（二）更正或补充您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正或补充。您可以通过本条“访问您的个人信息”中列明的方式提出更正或补充申请。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（三）删除您的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >您可以通过本条“访问您的个人信息”中列明的方式删除您的部分个人信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >在以下情形中，您可以向我们提出删除个人信息的请求：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、如果我们处理个人信息的行为违反法律法规；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、如果我们收集、使用您的个人信息，却未征得您的明确同意；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >3、如果我们处理个人信息的行为严重违反了与您的约定；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">4、如果您不再使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">的产品或服务，或您主动注销了账号；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >5、如果我们永久不再为您提供产品或服务。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >若我们决定响应您的删除请求，我们还将同时尽可能通知从我们处获得您的个人信息的主体，要求其及时删除，除非法律法规另有规定，或这些主体获得您的独立授权。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">当您从</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的服务中删除信息或我们协助您删除相关信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（四）修改或撤回您授权同意的范围</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">您可以通过删除信息、关闭设备功能、在</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >上进行隐私设置等方式改变您授权我们继续收集个人信息的范围或撤回您的授权。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >请您理解，每个业务功能需要一些基本的个人信息才能得以完成（见本隐私权政策“我们如何收集和使用您的信息”）。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（五）注销您的账户</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">您可通过“我</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">帮助反馈</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">我的客服</span
        ><span style="font-size: 16px"
          >”功能联系客服完成账户的注销，或在“我</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">设置</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">账号设置</span
        ><span style="font-size: 16px"
          >”功能中查看账户注销流程。请您谨慎操作，否则，因账户注销产生的数据丢失问题均由您自行承担。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">在符合</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >单项服务的服务协议约定条件及国家相关法律法规规定的情况下，您的该项</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >服务账号可能被注销或删除。当账号注销或被删除后，与该账号相关的、该单项服务项下的全部服务资料和数据将依照单项服务的服务协议约定删除或匿名化处理。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（六）约束信息系统自动决策</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >在某些互联网电子服务或产品中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将在不侵害我们和关联公司商业秘密或用户权益、社会公共利益的前提下提供申诉方法。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">（七）响应您的上述请求</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如您需要撤销授权信息或者注销、删除个人账号信息，您可通过本政策第九条约定的方式联系我们。为保障您的信息安全，我们可能需要您提供书面请求或其他方式证明您的身份，验证通过后即可处理您的请求。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">我们将会在</span
        ><span style="color: #0000ff; font-size: 16px">15</span
        ><span style="color: #0000ff; font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">个工作日内针对您</span
        ><span style="font-size: 16px">的</span
        ><span style="font-size: 16px">请求</span
        ><span style="font-size: 16px">作</span
        ><span style="font-size: 16px">出</span
        ><span style="font-size: 16px"
          >答复。如您不满意，可通过客服中心发起投诉。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际的请求，我们可能会予以拒绝。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">1、与国家安全、国防安全有关的；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、与公共安全、公共卫生、重大公共利益有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >3、与犯罪侦查、起诉、审判和执行判决等有关的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >4、有充分证据表明个人信息主体存在主观恶意或滥用权利的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >5、响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">6、涉及商业秘密的。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">六、我们如何处理未成年人的个人信息</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如果没有父母或监护人的同意，未成年人不得创建自己的用户账户。如您为未成年人的，我们要求您请您的父母或监护人仔细阅读本政策，并在征得您的父母或监护人同意的前提下使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px">的服务或产品或向我们提供信息。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">对于经父母或监护人同意使用</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >的服务或产品而收集未成年人个人信息的情况，我们只会在法律法规允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用、共享、转让或披露此信息。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">根据当地监管部门的相关规定，</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >仅对满足特定年龄要求的用户提供互联网电子服务或产品。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">七、您的个人信息如何在全球范围转移</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >我们在中华人民共和国境内运营中收集和产生的个人信息，存储在中国境内，以下情形除外：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">1、法律法规有明确规定；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">2、获得</span
        ><span style="font-size: 16px">你得明确</span
        ><span style="font-size: 16px">授权；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >3、您通过互联网进行海外互联网电子服务或商品等个人主动行为。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >针对以上情形，我们会确保依据本政策对您的个人信息提供足够的保护。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">八、本政策如何更新</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">我们的隐私权政策可能变更。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >未经您明确同意，我们不会削减您按照本政策所应享有的权利。
          我们会在本页面上发布对本政策所做的任何变更。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >对于重大变更，我们还会提供更为显著的通知（包括我们会通过在</span
        ><span style="font-size: 16px">灏睿云医</span
        ><span style="font-size: 16px"
          >上公示的方式进行通知甚至向您提供弹窗提示）。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >本政策所指的重大变更主要包括以下情形：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >1、我们的服务模式发生重大变化。如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、我们在所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >3、个人信息共享、转让或公开披露的主要对象发生变化；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >4、您参与个人信息处理方面的权利及其行使方式发生重大变化；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >5、我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >6、个人信息安全影响评估报告表明存在高风险时。</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">我们还会将本政策的</span
        ><a
          style="color: #000000"
          href="https://www.guahao.com/agreement/privacy-old"
          ><span
            style="
              background-color: #f7f8fc;
              font-size: 16px;
              letter-spacing: 0.55pt;
              text-decoration: none;
            "
            >旧版本</span
          ></a
        ><span style="font-size: 16px">存档，供您查阅。</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">&#xa0;</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">九、如何联系我们</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如您对本政策内容有任何疑问、意见或建议，或发现个人信息可能被泄露的，您可以通过以下方式与我们联系，一般情况下我们将在15个工作日内回复您的请求：</span
        >
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px">1、您可以通过“我</span
        ><span style="font-size: 16px">的</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">设置</span
        ><span style="font-size: 16px">-</span
        ><span style="font-size: 16px">联系客服</span
        ><span style="font-size: 16px">”</span
        ><span style="font-size: 16px">,</span
        ><span style="font-size: 16px">客服电话（</span
        ><span style="font-size: 16px">0756-8598915</span
        ><span style="font-size: 16px">）与我们联系；</span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >2、我们还设立了个人信息保护专职部门，您可以向我们提交书面通知，通知寄送地址为：</span
        ><span style="font-size: 16px"
          >广东省珠海市香洲区富华里中海大厦B座304</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">&#xa0;</span
        ><span style="font-size: 16px">灏睿云医技术部</span
        ><span style="font-size: 16px">（收），邮编：</span
        ><span style="font-size: 16px">519000</span
        ><span style="font-size: 16px"> </span
        ><span style="font-size: 16px"> </span>
      </p>
      <p
        style="
          font-size: 16px;
          line-height: 115%;
          margin: 0pt 0pt 10pt;
          orphans: 0;
          text-align: justify;
          widows: 0;
        "
      >
        <span style="font-size: 16px"
          >如果您对我们的回复不满意，特别是您认为我们的个人信息处理行为损害了您的合法权益，您还可以通过向本政策</span
        ><span style="font-size: 16px">签订地（</span
        ><span style="font-size: 16px">珠海</span
        ><span style="font-size: 16px">市横琴新区</span
        ><span style="font-size: 16px"
          >）有管辖权的法院提起诉讼来寻求解决方案。</span
        >
      </p>
    </div>
    <div v-else>
      <div class="userAgreement">
        <p style="text-align: center">法律声明</p>

        <p>一、权利归属</p>
        <p>
          除非灏睿云医另行声明，灏睿云医平台内的所有产品、技术、软件、程序、数据及其他信息（如文字、商标、图形、图片、照片、音频、视频、图表、色彩、版面设计、电子文档）的所有权利（如版权、商标权、专利权、商业秘密和其他所有相关权利）均归灏睿云医及/或相关权利人所有。未经灏睿云医及/或相关权利人事先许可，任何人不得通过机器人、蜘蛛等程序或设备监视、复制、转播、展示、镜像、上传、下载灏睿云医平台内的任何内容。
        </p>
        <p>
          灏睿云医的Logo、“灏睿云医”等文字、图形及其组合，以及灏睿云医的其他标识、徽记、产品和服务名称等为灏睿云医在中国和其他国家的商标或著作作品，如有宣传、展示等任何使用需要，您必须事先取得灏睿云医的书面授权。
        </p>
        <p>
          前述所称的灏睿云医，是指灏睿云医平台的软件技术服务提供者灏睿云医及其在中国境内设立或运营的实体，包括其直接或间接控股的企业，参股或形成经营、协作的具有关联关系的企业，（本声明中统称“灏睿云医”）；灏睿云医平台，是指灏睿云医网站（域名为www.hryunyi.com）、灏睿云医客户端、灏睿云医公众号以及灏睿云医小程序等（本声明中统称“灏睿云医平台”）。
        </p>

        <p>二、责任限制</p>
        <p>
          您在灏睿云医平台内自行上传、提供、发布相关信息，例如用户名称、公司名称、联系人及联络信息，相关图片、资讯等，该等信息均由您自行提供，您须对所提供的任何信息依法承担全部责任。灏睿云医对此另有约定的，将在相关的协议或其他法律文本中与您予以明确。
        </p>
        <p>
          灏睿云医转载作品（包括论坛内容）系出于传递更多信息之目的，并不意味灏睿云医赞同其观点或证实其内容的真实性。
        </p>
        <p>
          灏睿云医在此提示，您在使用灏睿云医平台所提供的服务期间应当遵守中华人民共和国的法律，不得危害网络安全，不得利用灏睿云医平台所提供的服务从事他人侵犯名誉、隐私、知识产权及/或其他合法权益的活动。尽管有前述提示，灏睿云医不对您使用灏睿云医平台所提供的服务的用途和目的承担任何责任。
        </p>

        <p>三、知识产权保护</p>
        <p>
          灏睿云医尊重知识产权，反对并打击侵犯知识产权的行为。任何组织或个人认为灏睿云医平台的内容（如发布的信息等）可能侵犯其合法权益的，可以通过邮件方式（邮箱：80888428@qq.com）向灏睿云医提出书面通知，通知内容应包含：
        </p>
        <p>
          （1）权利人的联络信息，包括姓名（名称）、身份证明（自然人为身份证或护照复印件、单位为营业执照（事业单位法人证书）等登记证明复印件）、联系方式、通信地址；
        </p>
        <p>（2）权利人对涉嫌侵权内容拥有合法权利的权属证明；</p>
        <p>
          （3）涉嫌侵权的内容及其出处（指网络地址或者足以准确定位侵权内容的相关信息）；（4）通知内容真实性声明。
        </p>
        <p>灏睿云医将在收到知识产权权利人合格通知后依法尽快处理。</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      type: "1",
    };
  },
  created() {
    this.gettypeOfDocument();
  },
  methods: {
    gettypeOfDocument() {
      let url = window.location.href;
      // let url = "http://localhost:8080/privacyPolicy?0";
      this.type = url.split("?").slice(-1)[0];
      console.log(this.type);
      switch (this.type) {
        case "0":
          this.$store.commit("setIsNative", true);
          console.log("用户协议");
          break;
        case "1":
          this.$store.commit("setIsNative", true);
          console.log("隐私政策");
          break;
        case "2":
          this.$store.commit("setIsNative", true);
          console.log("法律法规");
          break;
        default:
          this.type = "1";
          this.$store.commit("setIsNative", false);
          console.log("显示默认值");
          break;
      }
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 80%;
  margin: 50px auto;
  margin-top: 100px;
  font-size: 16px;
}
.boldFont {
  font-weight: bold;
  color: rgb(0, 0, 255) !important;
}
.userAgreement {
  > p {
    font-size: 16px;
    line-height: 115%;
    margin: 0pt 0pt 10pt;
    orphans: 0;
    text-align: justify;
    widows: 0;
  }
}
</style>